import Image from 'next/image';
import ReactMarkdown from 'react-markdown';
import { IMedia } from '../../../models/strapi.models';
import { TextblocksWithIconStyle } from '../../../styles/components/common/blocks';

export interface ITextblocksWithIconProps {
  title?: string;
  items: {
    content: string;
    icon: IMedia;
  }[];
  largeIcons?: boolean;
}

const TextblocksWithIcon = (props: ITextblocksWithIconProps) => {
  return (
    <div className={TextblocksWithIconStyle['text-blocks-with-icon']}>
      {props.title && (
        <h2 className={TextblocksWithIconStyle['text-blocks-with-icon-title']}>
          {props.title}
        </h2>
      )}
      <div
        className={`${TextblocksWithIconStyle['text-blocks-with-icon-items']} ${
          props.items.length === 2
            ? TextblocksWithIconStyle['text-blocks-with-icon-items-2-columns']
            : ''
        }`}>
        {props.items.map((item, index) => (
          <div
            key={index}
            className={TextblocksWithIconStyle['text-block-with-icon-item']}>
            {item.icon && (
              <Image
                src={item.icon.url!}
                alt={item.icon.alternativeText || ''}
                height={props.largeIcons ? 120 : 80}
                width={props.largeIcons ? 120 : 80}
              />
            )}
            <div>
              <ReactMarkdown>{item.content}</ReactMarkdown>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TextblocksWithIcon;
